import api from "./api";

function getSessionId() {
  try {
    let sid = localStorage.getItem("cs_sid");
    if (!sid) {
      sid = (crypto.randomUUID && crypto.randomUUID()) ||
        `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem("cs_sid", sid);
    }
    return sid;
  } catch {
    return "anon";
  }
}

let lastPath = null;

export function trackPageView(path) {
  if (path === lastPath) return;
  lastPath = path;
  // Google Analytics (loaded only if GA_MEASUREMENT_ID is configured in index.html)
  if (typeof window !== "undefined" && typeof window.gtag === "function" && window.__GA_ID) {
    window.gtag("event", "page_view", { page_path: path });
  }
  api
    .post("/analytics/pageview", {
      path,
      referrer: document.referrer || "",
      session_id: getSessionId(),
    })
    .catch(() => {});
}
